import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ShortcutTypeGlobal } from 'src/app/samwebDescription/samweb/shortcuts/shortcutTypeGlobal';
import { ShortcutBehaviourState } from 'src/app/store/samwin/shortcut-behaviour/shortcut-behaviour.state';
import { SettingsChangedHotkeyCombo } from 'src/app/store/settings/settings.actions';

@Component({
   selector: 'samweb-hotkey-duplicate-dialog',
   templateUrl: './hotkey-duplicate-dialog.component.html',
   styleUrls: ['./hotkey-duplicate-dialog.component.scss'],
})
export class HotkeyDuplicateDialogComponent implements OnInit {
   @Input()
   public shortcutTyp: ShortcutTypeGlobal;
   @Input()
   public eventShortcutString: string;

   public usedShortCuts$: Observable<ShortcutTypeGlobal[]>;

   constructor(private store: Store) {}
   ngOnInit(): void {
      this.usedShortCuts$ = this.store.select(ShortcutBehaviourState.getHotkeysWithShortCutCombo).pipe(map((fn) => fn(this.eventShortcutString)));
   }

   click() {
      this.store.dispatch(new SettingsChangedHotkeyCombo(this.shortcutTyp, this.eventShortcutString));
   }
}
